import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { GatsbyImageProps } from 'gatsby-plugin-image';
import React, { useContext } from 'react';

import { Image } from '../../index';
import * as styles from './ImageContent.module.css';

const ImageContent = ({
	children,
	image,
	alt,
	direction = 'ltr',
	as: Component = 'div',
}: {
	children: React.ReactNode;
	image: GatsbyImageProps;
	alt: string;
	direction?: 'ltr' | 'rtl';
	as?: React.ElementType;
}) => {
	const { variant } = useContext(ThemeContext);

	return (
		<Component className={cx(styles.box, styles[direction], styles[variant])}>
			<div className={styles.content}>{children}</div>
			<div className={styles.image}>
				<Image image={image} alt={alt} />
			</div>
		</Component>
	);
};

export default ImageContent;
